<template>
  <div class="price" :style="{ color: color }">
    <span style="font-size: 12px;">￥</span>
    <span :style="{ fontSize: mainSize + 'px' }" class="main-price">{{ intPrice }}</span>
    <span style="font-size: 12px;">.{{ floatPrice }}</span>
  </div>
</template>
<script>
export default {
  props: {
    price: { //单位是分，而不是元
      type: [Number, String],
      default: 0,
    },
    //
    mainSize: {
      type: [Number, String],
      default: 18,
    },
    color: {
      type: String,
      default: '#45C5DA',
    },
  },
  data() {
    return {
      intPrice: '',
      floatPrice: '',
    };
  },
  watch: {
    price: {
      handler(nval) {
        let price = (nval/100).toFixed(2);
        //价格的整数部分
        this.intPrice = price.split('.')[0];
        //价格的小数部分
        this.floatPrice = price.split('.')[1];
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import 'common/sass/theme.scss';
.price {
  font-size: 14px;
  /*font-weight: bold;*/
  .main-price {
  }
}
</style>
